import { PropsWithChildren } from "react";

import { VDiv } from "./Div";

type LoadingProps = {
  text?: string;
  additionalClasses?: string;
};

export const Loading = ({
  text = "Loading...",
  additionalClasses,
  children,
}: PropsWithChildren<LoadingProps>) => {
  return (
    <VDiv
      data-component="Loading"
      className={`items-center 
      justify-center py-4 text-body ${additionalClasses}`}
    >
      <img src={"/logo.svg"} width={30} height={30} alt="Vayda logo" />
      <span className="mt-5">{text}</span>
      {children}
    </VDiv>
  );
};
